/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import i18n from "../live/js/common/i18n";

require('./bootstrap');

import 'swiper/dist/css/swiper.css';
import Swiper from 'swiper';

import router from './router'
import store from './store'
import * as types from './store/mutations'
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat' // load on demand
import 'dayjs/locale/ro'
import 'dayjs/locale/bg'
import 'dayjs/locale/hr'
import dayjsPluginUTC from 'dayjs/plugin/utc'

import VueLazyload from 'vue-lazyload'
import PhotoSwipe from 'photoswipe/dist/photoswipe.min'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.min'
import Notifications from 'vue-notification'
import Vue from 'vue';
import VueTour from 'vue-tour'
import VeeValidate from 'vee-validate';
import Cookies from 'js-cookie';
import iziToast from 'izitoast/dist/js/iziToast.min';

//import VueSocketIO from './components/widgets/A10LiveWidget/Vue-Socket.io'
import VueCurrencyFilter from 'vue-currency-filter'
import {NULL} from "sass";

require('vue-tour/dist/vue-tour.css')

Vue.use(VeeValidate);
Vue.use(VueTour);
Vue.use(Notifications)

window.Vue = require('vue');
window.Cookies = require('js-cookie');

dayjs.extend(dayjsPluginUTC)

Object.defineProperty(Vue.prototype, '$dayjs', {value: dayjs});
Object.defineProperty(Vue.prototype, '$pswp', {value: PhotoSwipe});
Object.defineProperty(Vue.prototype, '$Cookies', {value: Cookies});

dayjs.extend(advancedFormat); // use plugin
dayjs.locale('ro');
dayjs.locale('bg');
dayjs.locale('hr');

store.subscribe((mutation, state) => {
    if (mutation.type == types.AUCTION_SET_SHOW) {
        localStorage.setItem('show', JSON.stringify(state.Auction.show));
    }
    if (mutation.type == types.AUCTION_SET_ORDER) {
        localStorage.setItem('order', JSON.stringify(state.Auction.order));
    }
    if (mutation.type == types.AUCTION_RESULTS_SET_ORDER) {
        localStorage.setItem('results_order', JSON.stringify(state.Auction.results_order));
    }
});


//Vue.use(new VueSocketIO({
//  debug: true,
//  connection: 'http://live.artmark.ro:8080',
//  options: {
//    transports: ['polling', 'websocket', 'flashsocket'],
//    query: 'auction=&token=guest',
//  }
//}))

Vue.use(VueCurrencyFilter, {
    symbol: '€',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: false
})

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.component('google', require('./components/GoogleMap.vue').default);
Vue.component('reset', require('./components/reset.vue').default);
Vue.component('auctions', require('./components/Auctions.vue').default);
//Vue.component('a10livewidget', require('./components/widgets/A10LiveWidget/A10LiveWidget.vue').default);
Vue.component('passport-clients', require('./components/passport/Clients.vue').default);
Vue.component('passport-authorized-clients', require('./components/passport/AuthorizedClients.vue').default);
Vue.component('passport-personal-access-tokens', require('./components/passport/PersonalAccessTokens.vue').default);
Vue.component('won-lots', require('./components/MyA10/WonLots.vue').default);
Vue.component('live-banner', require('./components/LiveBanner.vue').default);

Vue.use(VueLazyload);


window.vm = new Vue({
    store,
    router
}).$mount('#app');

var elem = document.querySelector('.main-carousel');
var flkty = new Flickity(elem, {
    lazyLoad: true,
    imagesLoaded: true,
    cellAlign: 'left',
    adaptiveHeight: true,
    contain: true,
    autoPlay: true,
    //autoPlay: 4500,
    wrapAround: true,
    fade: true
});

// var swiper_main_landing = new Swiper('.swiper-main-landing', {
//     centeredSlides: true,
//     loop: true,
//     slidesPerView: 'auto',
//     effect: 'fade',
//     preloadImages: false,
//     lazy: true,
//     fadeEffect: {
//         crossFade: true
//     },
//     autoplay: {
//         delay: 5000,
//         disableOnInteraction: false,
//     },
//     // If we need pagination
//     //    pagination: {
//     //      el: '.swiper-pagination-main-landing',
//     //      paginationClickable: true,
//     //      type: 'bullets',
//     //      bulletElement: 'span',
//     //      clickable: true,
//     //    },
//
//     // Navigation arrows
//     navigation: {
//         nextEl: '.next-main-landing',
//         prevEl: '.prev-main-landing',
//     },
// });

var swiper_video_landing = new Swiper('.swiper-video-landing', {
    loop: true,
    slidesPerView: 2,
    spaceBetween: 30,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    // If we need pagination
    pagination: {
        el: '.swiper-pagination-video-landing',
        paginationClickable: true,
        type: 'bullets',
        bulletElement: 'span',
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: '.next-video-landing',
        prevEl: '.prev-video-landing',
    },
    breakpoints: {
        992: {
            slidesPerView: 1,
            spaceBetween: 40,
        },
        768: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        576: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        320: {
            slidesPerView: 1,
            spaceBetween: 10,
        }
    }
});

var swiper_footer = new Swiper('.swiper-footer', {
    parallax: true,
    slidesPerView: 5,
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    // Navigation arrows
    pagination: {
        el: '.swiper-pagination-footer',
        paginationClickable: true,
        type: 'bullets',
        bulletElement: 'span',
        clickable: true,
    },
    breakpoints: {
        992: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        576: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        320: {
            slidesPerView: 2,
            spaceBetween: 10,
        }
    }
});

$(document).on('change', '.btn-file :file', function () {
    var input = $(this),
        label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
    input.trigger('fileselect', [label]);
});

$('.btn-file :file').on('fileselect', function (event, label) {
    var input = $(this).parents('.upload-input-group').find(':text'),
        log = label;
    if (input.length) {
        input.val(log);
    } else {
        if (log) alert(log);
    }
});

$("#searchCollapse").mouseenter(function () {
    $(this).find('p').css('height', $(this).find('span').height());
})

$("#searchCollapse").mouseleave(function () {
    $(this).find('p').css('height', 0);
})

//PSWP

window.initPhotoSwipeFromDOM = function (gallerySelector) {
    var parseThumbnailElements = function (el) {
        var all = document.querySelectorAll(gallerySelector);
        var items = [];
        for (var j = 0; j < all.length; j++) {
            var el = all[j];
            var thumbElements = el.parentNode.childNodes;
            var numNodes = thumbElements.length,
                figureEl,
                linkEl,
                size,
                item;
            for (var i = 0; i < numNodes; i++) {
                figureEl = thumbElements[i];

                if (figureEl.nodeType !== 1) {
                    continue;
                }
                linkEl = figureEl.children[0];
                size = linkEl.getAttribute('data-size').split('x');
                if ($(linkEl).data('type') == 'video') {
                    item = {
                        html: $(linkEl).data('video')
                    };
                } else {
                    item = {
                        src: linkEl.getAttribute('href'),
                        w: parseInt(size[0], 10),
                        h: parseInt(size[1], 10)
                    };
                }

                if (figureEl.children.length > 1) {
                    item.title = figureEl.children[1].innerHTML;
                }
                if (linkEl.children.length > 0) {
                    item.msrc = linkEl.children[0].getAttribute('src');
                }

                item.el = figureEl;
                items.push(item);
            }
        }
        return items;
    };
    var closest = function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
    };
    var onThumbnailsClick = function (e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;
        var eTarget = e.target || e.srcElement;
        var clickedListItem = closest(eTarget, function (el) {
            return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
        });
        if (!clickedListItem) {
            return;
        }
        var clickedGallery = clickedListItem.parentNode,
            childNodes = document.querySelectorAll(gallerySelector),
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;
        for (var i = 0; i < numChildNodes; i++) {
            if (childNodes[i].nodeType !== 1) {
                continue;
            }
            if (childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }
        if (index >= 0) {
            openPhotoSwipe(index, clickedGallery);
        }
        return false;
    };
    var photoswipeParseHash = function () {
        var hash = window.location.hash.substring(1),
            params = {};
        if (hash.length < 5) {
            return params;
        }
        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if (!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');
            if (pair.length < 2) {
                continue;
            }
            params[pair[0]] = pair[1];
        }
        if (params.gid) {
            params.gid = parseInt(params.gid, 10);
        }
        return params;
    };

    var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;
        items = parseThumbnailElements(galleryElement);
        options = {
            maxSpreadZoom: 5,
            galleryUID: galleryElement.getAttribute('data-pswp-uid'),
            getThumbBoundsFn: function (index) {
                var thumbnail = items[index].el.getElementsByTagName('img')[0],
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                    rect = thumbnail.getBoundingClientRect();
                return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
            },
            minZoom: 3,

        };
        if (fromURL) {
            if (options.galleryPIDs) {
                for (var j = 0; j < items.length; j++) {
                    if (items[j].pid == index) {
                        options.index = j;
                        break;
                    }
                }
            } else {
                options.index = parseInt(index, 10) - 1;
            }
        } else {
            options.index = parseInt(index, 10);
        }
        if (isNaN(options.index)) {
            return;
        }
        if (disableAnimation) {
            options.showAnimationDuration = 0;
        }
        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

        var a = gallery.init();
        var ratioFix;
        gallery.listen('initialZoomIn', function () {
            var el = document.querySelectorAll('.pswp__item')[1];
            el.className += (el.className ? ' ' : '') + 'pswp__item--ratiofix';
            ratioFix = true;
        });

        gallery.listen('initialZoomInEnd', function () {
            var ratiofixTimer = window.setInterval(function () {
                var el = document.querySelectorAll('.pswp__item--ratiofix .pswp__img')[1];
                if (typeof (el) != 'undefined' && el != null) {
                    window.clearInterval(ratiofixTimer);
                    el.style.opacity = 1;
                }
            }, 10);
        });

        gallery.listen('afterChange', function () {
            if (ratioFix == true) {

                var el = document.querySelectorAll('.pswp__item--ratiofix')[0];
                var reg = new RegExp('(\\s|^)' + 'pswp__item--ratiofix' + '(\\s|$)');
                el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
                ratioFix = false;
            }
        });
        return a;
    };
    var galleryElements = document.querySelectorAll(gallerySelector);
    for (var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i + 1);
        galleryElements[i].onclick = onThumbnailsClick;
    }
    var hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
        openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
    }
};

window.showToast = function (msg, type, position = null, target = null, classes = null, displayMode = 'replace') {
    var color;
    if (type === "success") {
        color = "green";
    } else if (type === "error") {
        color = "red";
    } else if (type === "warning") {
        color = "#ffcc00";
    } else {
        color = "grey";
    }
    if (classes == null) {
        classes = 'rounded-0';
    } else {
        classes = classes + ' rounded-0';
    }
    if (position != null) {
        iziToast.show({
            class: classes,
            message: msg,
            color: color,
            position: position,
            transitionIn: 'bounceInLeft',
            progressBar: false,
            timeout: 10000,
            displayMode: 'replace'
        });
    } else {
        iziToast.show({
            class: classes,
            message: msg,
            color: color,
            target: target,
            transitionIn: 'bounceInLeft',
            progressBar: false,
            timeout: 10000,
            displayMode: 'replace'
        });
    }

}

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};

$(document).ready(function () {
    $('body').focus();
})

//SIDENAV

// Look for .hamburger
var hamburger = document.querySelector(".hamburger");

// On click

function toggleHamIcon() {
    hamburger.classList.toggle("is-active");
}

var $menu = $('#sidenav');
var $menuToggle = $('#sidenav-toggle');
var $filter = $('#filter');

function isHidden(el) {
    return $(el).is(":hidden");
}

window.toggle_sidenav = function () {
    toggleHamIcon();
    if ($('#sidenav').hasClass('show')) {
        $('.sidenav-open-path').show();
        $('.sidenav-close-path').hide();
        if ($('body').hasClass('noscroll')) {
            $('body').removeClass('noscroll');
        }
        if ($('#app-content').hasClass('translucid')) {
            $('#app-content').removeClass('translucid');
        }
    } else {
        $('.sidenav-close-path').show();
        $('.sidenav-open-path').hide();
        if (!$('body').hasClass('noscroll')) {
            $('body').addClass('noscroll');
        }
        if (!$('#app-content').hasClass('translucid')) {
            $('#app-content').addClass('translucid');
        }
        if (!isHidden($('#searchCollapse'))) {
            $('#searchCollapse').collapse('hide');
        }
        if (!isHidden($('#searchCollapse'))) {
            $('#dropdown-menu-container').collapse('hide');
        }
    }
}

$('body').click(function (e) {
    if (!$menu.is(e.target) && $menu.has(e.target).length === 0 && !$menuToggle.is(e.target) && $menuToggle.has(e.target).length == 0) {
        if ($('#sidenav').hasClass('show')) {
            toggle_sidenav();
        }
    }
});


function swipedetect(callback) {
    var touchsurface = document.body,
        swipedir,
        startX,
        startY,
        distX,
        distY,
        threshold = 150, //required min distance traveled to be considered swipe
        restraint = 100, // maximum distance allowed at the same time in perpendicular direction
        allowedTime = 300, // maximum time allowed to travel that distance
        elapsedTime,
        startTime,
        handleswipe = callback || function (swipedir) {
        }

    touchsurface.addEventListener('touchstart', function (e) {
        try {
            if (e.target.className.includes('swiper') || e.target.className.includes('pswp')) {
                return;
            }
        } catch (err) { //supress error when clicking on figures
        }
        var touchobj = e.changedTouches[0]
        swipedir = 'none'
        var dist = 0
        startX = touchobj.pageX
        startY = touchobj.pageY
        startTime = new Date().getTime() // record time when finger first makes contact with surface

        //e.preventDefault();
    }, false)

    touchsurface.addEventListener('touchmove', function (e) {
        //e.preventDefault() // prevent scrolling when inside DIV
    }, false)

    touchsurface.addEventListener('touchend', function (e) {
        var touchobj = e.changedTouches[0]
        distX = touchobj.pageX - startX // get horizontal dist traveled by finger while in contact with surface
        distY = touchobj.pageY - startY // get vertical dist traveled by finger while in contact with surface
        elapsedTime = new Date().getTime() - startTime // get time elapsed
        if (elapsedTime <= allowedTime) { // first condition for awipe met
            if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) { // 2nd condition for horizontal swipe met
                swipedir = (distX < 0) ? 'left' : 'right' // if dist traveled is negative, it indicates left swipe
            } else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) { // 2nd condition for vertical swipe met
                swipedir = (distY < 0) ? 'up' : 'down' // if dist traveled is negative, it indicates up swipe
            }
        }
        handleswipe(swipedir)

    }, false)
}

swipedetect(function (swipedir) {
    if (!isHidden($menuToggle)) {
        if (swipedir === 'left') {
            if (isHidden($menu)) {
                toggle_sidenav();
            }
        } else if (swipedir === 'right') {
            if (!isHidden($menu)) {
                toggle_sidenav();
            }
        }
    }

});

function elementInViewport(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return (
        top >= window.pageYOffset &&
        left >= window.pageXOffset &&
        (top + height) <= (window.pageYOffset + window.innerHeight) &&
        (left + width) <= (window.pageXOffset + window.innerWidth)
    );
}


//SUBSCRIBE

window.showToast = function (msg, type, position = null, target = null, classes = null, displayMode = 'replace') {
    var color;
    if (type === "success") {
        color = "green";
    } else if (type === "error") {
        color = "red";
    } else if (type === "warning") {
        color = "#ffcc00";
    } else {
        color = "grey";
    }
    if (classes == null) {
        classes = 'rounded-0';
    } else {
        classes = classes + ' rounded-0';
    }
    if (position != null) {
        iziToast.show({
            class: classes,
            message: msg,
            color: color,
            position: position,
            transitionIn: 'bounceInLeft',
            progressBar: false,
            timeout: 10000,
            displayMode: 'replace'
        });
    } else {
        iziToast.show({
            class: classes,
            message: msg,
            color: color,
            target: target,
            transitionIn: 'bounceInLeft',
            progressBar: false,
            timeout: 10000,
            displayMode: 'replace'
        });
    }

}

window.subscribe = function (source = null) {

    let file = 'api_messages';
    let key = null;
    let translations = null;
    let message = null;

    axios.post('/api/get-translations', {
        locale: window.locale,
        file: file,
        key: key,
    }).then((response) => {
        translations = response.data.message;
        var email = document.getElementById('subscriber-email').value;
        var name = document.getElementById('subscriber-name').value;
        if (source == 'modal') {
            // alert(source);
            email = document.getElementById('subscriber-email-modal').value;
            name = document.getElementById('subscriber-name-modal').value;
        }

        document.getElementById('newsletter-text').classList.add('d-none');
        document.getElementById('newsletter-loading').classList.remove('d-none');
        document.getElementById('newsletter-subscribe-btn').disabled = true;

        if (email == "") {
            message = translations['email-required'];
            window.showToast(message, 'error', 'topCenter')
            document.getElementById('newsletter-text').classList.remove('d-none');
            document.getElementById('newsletter-loading').classList.add('d-none');
            document.getElementById('newsletter-subscribe-btn').disabled = false;
        } else if (name == "") {
            message = translations['name-required'];
            window.showToast(message, 'error', 'topCenter')
            document.getElementById('newsletter-text').classList.remove('d-none');
            document.getElementById('newsletter-loading').classList.add('d-none');
            document.getElementById('newsletter-subscribe-btn').disabled = false;
        }else{
            axios.post('/api/subscribe', {
                email: email,
                name: name,
                locale: window.locale
            }).then((response) => {
                window.showToast(response.data.message, 'success', 'topCenter');
                document.getElementById('subscriber-email').value = "";
                document.getElementById('subscriber-name').value = "";
                document.getElementById('newsletter-text').classList.remove('d-none');
                document.getElementById('newsletter-loading').classList.add('d-none');
                document.getElementById('newsletter-subscribe-btn').disabled = false;
                var d = new Date();
                document.cookie = "time=" + d;
                setCookie('subs_nws', "time=" + d, 365);
                $('#subscribeModal').modal('hide');
            }).catch((error) => {
                if (error.response) {
                    window.showToast(error.response.data.message, 'error', 'topCenter');
                } else {
                    window.showToast(translations['unknown-error'], 'error', 'topCenter');
                }
                document.getElementById('newsletter-text').classList.remove('d-none');
                document.getElementById('newsletter-loading').classList.add('d-none');
                document.getElementById('newsletter-subscribe-btn').disabled = false;

            });
        }
    }).catch((error) => {
    });

};

window.goToAuction = function (url) {
    if (url !== null) {
        window.location.replace(url);
    }
}

// window.displayOnlineCampaign = function (locale) {
//     var elem = document.getElementById("landingPageCampaignOnline");
//     if ($('#landingPageCampaignOnline').hasClass("d-none")) {
//         $('#landingPageCampaignOnline').removeClass("d-none");
//         var detailsText = (locale === "ro") ? 'Ascunde detalii' : 'Hide details';
//         $('#toggleCampaignDetails').text(detailsText);
//     } else {
//         $('#landingPageCampaignOnline').addClass("d-none");
//         var detailsText = (locale === "ro") ? 'Vezi detalii' : 'See details';
//         $('#toggleCampaignDetails').text(detailsText);
//     }
// }

//FOOTER MENU


var acc = document.getElementsByClassName("clickable");
for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
        var hoverable = this.getElementsByClassName("hoverable-menu")[0];
        if (hoverable != null) {
            hoverable.classList.toggle("hoverable-menu-active");
        }
        var clickables = document.getElementsByClassName("clickable");
        for (let j = 0; j < clickables.length; j++) {
            if (clickables[j] != this) {
                var show = clickables[j].getElementsByClassName("show")[0];
                if (show) {
                    var hoverable = clickables[j].getElementsByClassName("hoverable-menu")[0];
                    hoverable.classList.toggle("hoverable-menu-active");
                    show.classList.remove('show');
                }
            }
        }

    });
}


//GDPR

var cookie_statement_link = '/Nota_de_informare_Artmark_RO.pdf';// /privacy-policy
!function (e) {
    var o = !1;
    if ("function" == typeof define && define.amd && (define(e), o = !0), "object" == typeof exports && (module.exports = e(), o = !0), !o) {
        var t = window.Cookies, n = window.Cookies = e();
        n.noConflict = function () {
            return window.Cookies = t, n
        }
    }
}(function () {
    function k() {
        for (var e = 0, o = {}; e < arguments.length; e++) {
            var t = arguments[e];
            for (var n in t) o[n] = t[n]
        }
        return o
    }

    return function e(p) {
        function f(e, o, t) {
            var n;
            if ("undefined" != typeof document) {
                if (1 < arguments.length) {
                    if ("number" == typeof (t = k({path: "/"}, f.defaults, t)).expires) {
                        var i = new Date;
                        i.setMilliseconds(i.getMilliseconds() + 864e5 * t.expires), t.expires = i
                    }
                    t.expires = t.expires ? t.expires.toUTCString() : "";
                    try {
                        n = JSON.stringify(o), /^[\{\[]/.test(n) && (o = n)
                    } catch (e) {
                    }
                    o = p.write ? p.write(o, e) : encodeURIComponent(String(o)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), e = (e = (e = encodeURIComponent(String(e))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape);
                    var c = "";
                    for (var a in t) t[a] && (c += "; " + a, !0 !== t[a] && (c += "=" + t[a]));
                    return document.cookie = e + "=" + o + c
                }
                e || (n = {});
                for (var r = document.cookie ? document.cookie.split("; ") : [], s = /(%[0-9A-Z]{2})+/g, d = 0; d < r.length; d++) {
                    var l = r[d].split("="), m = l.slice(1).join("=");
                    this.json || '"' !== m.charAt(0) || (m = m.slice(1, -1));
                    try {
                        var u = l[0].replace(s, decodeURIComponent);
                        if (m = p.read ? p.read(m, u) : p(m, u) || m.replace(s, decodeURIComponent), this.json) try {
                            m = JSON.parse(m)
                        } catch (e) {
                        }
                        if (e === u) {
                            n = m;
                            break
                        }
                        e || (n[u] = m)
                    } catch (e) {
                    }
                }
                return n
            }
        }

        return (f.set = f).get = function (e) {
            return f.call(f, e)
        }, f.getJSON = function () {
            return f.apply({json: !0}, [].slice.call(arguments))
        }, f.defaults = {}, f.remove = function (e, o) {
            f(e, "", k(o, {expires: -1}))
        }, f.withConverter = e, f
    }(function () {
    })
}), window["gdpr-cookie-notice-templates"] = {}, window["gdpr-cookie-notice-templates"]["bar.html"] = '<div class="gdpr-cookie-notice">\n  <p class="gdpr-cookie-notice-description">{description}</p>\n  <nav class="gdpr-cookie-notice-nav">\n    <a href="#" class="gdpr-cookie-notice-nav-item gdpr-cookie-notice-nav-item-settings" id="show-cookies">{settings}</a>\n    <a href="#" class="gdpr-cookie-notice-nav-item gdpr-cookie-notice-nav-item-accept gdpr-cookie-notice-nav-item-btn">{accept}</a>\n  </nav>\n</div>\n', window["gdpr-cookie-notice-templates"]["category.html"] = '<li class="gdpr-cookie-notice-modal-cookie">\n  <div class="gdpr-cookie-notice-modal-cookie-row">\n    <h3 class="gdpr-cookie-notice-modal-cookie-title">{title}</h3>\n    <input type="checkbox" name="gdpr-cookie-notice-{prefix}" checked="checked" id="gdpr-cookie-notice-{prefix}" class="gdpr-cookie-notice-modal-cookie-input">\n    <label class="gdpr-cookie-notice-modal-cookie-input-switch" for="gdpr-cookie-notice-{prefix}"></label>\n  </div>\n  <p class="gdpr-cookie-notice-modal-cookie-info">{desc}</p>\n</li>\n', window["gdpr-cookie-notice-templates"]["modal.html"] = '<div class="gdpr-cookie-notice-modal">\n  <div class="gdpr-cookie-notice-modal-content">\n    <div class="gdpr-cookie-notice-modal-header">\n      <h2 class="gdpr-cookie-notice-modal-title">{settings}</h2>\n      <button type="button" class="gdpr-cookie-notice-modal-close" style="cursor:pointer;"></button>\n    </div>\n    <ul class="gdpr-cookie-notice-modal-cookies"></ul>\n    <div class="gdpr-cookie-notice-modal-footer">\n      <a target="_blank" href="{cookie_info}" class="gdpr-cookie-notice-modal-footer-item gdpr-cookie-notice-modal-footer-item-statement">{statement}</a>\n      <a href="#" id="gdpr-cookie-notice-modal-footer-item-btn" class="gdpr-cookie-notice-modal-footer-item gdpr-cookie-notice-modal-footer-item-save gdpr-cookie-notice-modal-footer-item-btn"><span>{save}</span></a>\n    </div>\n  </div>\n</div>\n';
function consentGranted() {
    gtag('consent', 'update', {
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted',
        'analytics_storage': 'granted'
    });
}
var gdprCookieNoticeLocales = {};

function gdprCookieNotice(c) {
    var n = "artmark_gdpr_cookie_notice", a = "gdpr-cookie-notice", r = window[a + "-templates"], i = Cookies, s = !1,
        d = !1, l = !1, m = ["performance", "analytics", "marketing"];
    c.locale || (c.locale = "en"), c.timeout || (c.timeout = 500), c.domain || (c.domain = null), c.expiration || (c.expiration = 30);
    var u = i.getJSON(n), p = new CustomEvent("gdprCookiesEnabled", {detail: u});

    function f(e) {
        for (var o = !1, t = 0; t < m.length; t++) if (c[m[t]] && !e[m[t]]) for (var n = 0; n < c[m[t]].length; n++) i.remove(c[m[t]][n]), o = !0;
        o ? g() : document.documentElement.classList.remove(a + "-loaded")
    }

    function k(e) {
        var o = {date: new Date, necessary: !0, performance: !0, analytics: !0, marketing: !0};
        if (e) for (var t = 0; t < m.length; t++) o[m[t]] = document.getElementById(a + "-cookie_" + m[t]).checked;
        i.set(n, o, {
            expires: c.expiration,
            domain: c.domain
        }), f(o), p = new CustomEvent("gdprCookiesEnabled", {detail: o}), document.dispatchEvent(p)
        consentGranted();
    }

    function e() {
        if (d) return !1;
        var e, o, t = v("bar.html");
        document.body.insertAdjacentHTML("beforeend", t), e = document.querySelectorAll("." + a + "-nav-item-settings")[0], o = document.querySelectorAll("." + a + "-nav-item-accept")[0], e.addEventListener("click", function (e) {
            e.preventDefault(), h()
        }), o.addEventListener("click", function (e) {
            e.preventDefault(), k()
        }), d = !0
    }

    function g() {
        e(), setTimeout(function () {
            document.documentElement.classList.add(a + "-loaded")
        }, c.timeout)
    }

    function v(e, t) {
        var o = r[e], n = gdprCookieNoticeLocales[c.locale];
        if (t ? t += "_" : t = "", !("string" == typeof o && n instanceof Object)) return !1;
        for (var i in n) return o.replace(/({([^}]+)})/g, function (e) {
            var o = e.replace(/{/, "").replace(/}/, "");
            return "prefix" == o ? t.slice(0, -1) : n[o] ? n[o] : n[t + o] ? n[t + o] : e
        })
    }

    function o() {
        if (s) return !1;
        var e = v("modal.html");
        document.body.insertAdjacentHTML("beforeend", e);
        var o = document.querySelector("." + a + "-modal-cookies");
        o.innerHTML += v("category.html", "cookie_essential");
        var t = document.querySelector("." + a + "-modal-cookie-input"),
            n = document.querySelector("." + a + "-modal-cookie-input-switch");
        n.innerHTML = gdprCookieNoticeLocales[c.locale].always_on, n.classList.add(a + "-modal-cookie-state"), n.classList.remove(a + "-modal-cookie-input-switch"), t.remove(), c.performance && (o.innerHTML += v("category.html", "cookie_performance")), c.analytics && (o.innerHTML += v("category.html", "cookie_analytics")), c.marketing && (o.innerHTML += v("category.html", "cookie_marketing")), function () {
            var e = document.querySelectorAll("." + a + "-modal-close")[0],
                o = document.querySelectorAll("." + a + "-modal-footer-item-statement")[0],
                t = document.querySelectorAll("." + a + "-modal-cookie-title"),
                n = document.querySelectorAll("." + a + "-modal-footer-item-save")[0];
            e.addEventListener("click", function () {
                document.documentElement.classList.remove("gdpr-cookie-notice-loaded");
                document.documentElement.classList.remove("gdpr-cookie-notice-show-modal");
                return !1
            }), o.addEventListener("click", function (e) {
            });
            for (var i = 0; i < t.length; i++) t[i].addEventListener("click", function () {
                return this.parentNode.parentNode.classList.toggle("open"), !1
            });
            n.addEventListener("click", function (e) {
                e.preventDefault(), n.classList.add("saved"), setTimeout(function () {
                    n.classList.remove("saved");
                    document.documentElement.classList.remove("gdpr-cookie-notice-loaded");
                    document.documentElement.classList.remove("gdpr-cookie-notice-show-modal");
                }, 1e3), k(!0);
            })
        }(), u && (document.getElementById(a + "-cookie_performance").checked = u.performance, document.getElementById(a + "-cookie_analytics").checked = u.analytics, document.getElementById(a + "-cookie_marketing").checked = u.marketing), s = !0
    }

    function h() {
        o(), document.documentElement.classList.add(a + "-show-modal")
    }

    u ? (f(u), document.dispatchEvent(p)) : (g(), c.implicit && window.addEventListener("scroll", function e() {
        var o, t, n, i, c;
        o = window.innerHeight || (document.documentElement || document.body).clientHeight, c = document, t = Math.max(c.body.scrollHeight, c.documentElement.scrollHeight, c.body.offsetHeight, c.documentElement.offsetHeight, c.body.clientHeight, c.documentElement.clientHeight), n = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop, i = t - o, 25 < Math.floor(n / i * 100) && !l && (l = !0) && (k(), window.removeEventListener("click", e))
    }));
    var t = document.querySelectorAll("." + a + "-settings-button");
    if (t) for (var y = 0; y < t.length; y++) t[y].addEventListener("click", function (e) {
        e.preventDefault(), h()
    })
}

gdprCookieNoticeLocales.en = {
    description: "We use cookies to offer you a better browsing experience, personalise content and ads, to provide social media features and to analyse our traffic. Read about how we use cookies and how you can control them by clicking Cookie Settings. You consent to our cookies if you continue to use this website.",
    settings: "Cookie settings",
    accept: "Accept cookies",
    statement: "Privacy policy",
    save: "Save settings",
    always_on: "Always on",
    cookie_essential_title: "Essential website cookies",
    cookie_essential_desc: "Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.",
    cookie_performance_title: "Performance cookies",
    cookie_performance_desc: "These cookies are used to enhance the performance and functionality of our websites but are non-essential to their use. For example it stores your preferred language or the region that you are in.",
    cookie_analytics_title: "Analytics cookies",
    cookie_analytics_desc: "We use analytics cookies to help us measure how users interact with website content, which helps us customize our websites and application for you in order to enhance your experience.",
    cookie_marketing_title: "Marketing cookies",
    cookie_marketing_desc: "These cookies are used to make advertising messages more relevant to you and your interests. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.",
    cookie_info: '/Nota_de_informare_Artmark_EN.pdf'
};

window.InitGDPR = function (locale) {
    if (locale === "ro") {
        gdprCookieNoticeLocales.en = {
            description: 'Utilizăm modulele cookie pentru a vă oferi o experiență mai bună de navigare, pentru a personaliza conținutul și anunțurile, pentru a oferi funcții media sociale și pentru a analiza traficul nostru. Citiți despre modul în care folosim modulele cookie și cum le puteți controla făcând clic pe Setări cookie. Sunteți de acord cu cookie-urile noastre dacă continuați să utilizați acest site web.',
            settings: 'Setări cookies',
            accept: 'Acceptați cookie-uri',
            statement: 'Politică de confidențialitate',
            save: 'Salvează setările',
            always_on: 'Întotdeauna pornit',
            cookie_essential_title: 'Cookie-uri esențiale',
            cookie_essential_desc: 'Cookie-urile necesare vă ajută să creați un site web ușor de utilizat, permițând funcții de bază cum ar fi navigarea pe pagini și accesul în zonele securizate ale site-ului web. Site-ul web nu poate funcționa corect fără aceste cookie-uri.',
            cookie_performance_title: 'Cookie-uri de performanță',
            cookie_performance_desc: 'Aceste cookie-uri sunt folosite pentru a îmbunătăți performanța și funcționalitatea site-urilor noastre, dar nu sunt esențiale pentru utilizarea lor. De exemplu, stochează limba dvs. preferată sau regiunea în care vă aflați.',
            cookie_analytics_title: 'Cookie-uri de statistici',
            cookie_analytics_desc: 'Utilizăm cookie-urile de statistici pentru a ne ajuta să măsuram modul în care utilizatorii interacționează cu conținutul site-ului, ceea ce ne ajută să personalizăm site-urile și aplicațiile noastre pentru a vă îmbunătăți experiența.',
            cookie_marketing_title: 'Cookie-uri de marketing',
            cookie_marketing_desc: 'Aceste module cookie sunt folosite pentru a face mesajele publicitare mai relevante pentru dvs. și interesele dvs. Intenția este de a afișa anunțuri relevante și angajate pentru utilizatorul individual și, prin urmare, mai valoroase pentru editori și pentru agenții de publicitate terță parte.',
            cookie_info: '/Nota_de_informare_Artmark_RO.pdf'
        }
    }
    gdprCookieNotice({
        locale: 'en', //This is the default value
        timeout: 500, //Time until the cookie bar appears
        expiration: 200, //This is the default value, in days
        domain: '', //If you run the same cookie notice on all subdomains, define the main domain starting with a .
        implicit: false, //Accept cookies on scroll
        statement: cookie_statement_link, //Link to your cookie statement page
        performance: ['JSESSIONID'], //Cookies in the performance category.
        analytics: ['ga'], //Cookies in the analytics category.
        marketing: ['SSID'] //Cookies in the marketing category.
    });

}


// Sticky navbar
// =========================
$(document).ready(function () {
    $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    setInterval(function () {
        if (isHidden($menu)) {
            if ($('#app-content').hasClass('translucid')) {
                toggle_sidenav();
            }
        }
        var spacing = "mt-4 pt-4";
        if (!$($menuToggle).isInViewport()) {

            if ($('.sidenav-container').hasClass(spacing)) {
                $('.sidenav-container').removeClass(spacing);
            }
        } else {
            if (!$('.sidenav-container').hasClass(spacing)) {
                $('.sidenav-container').addClass(spacing);
            }
        }
    }, 1000);

    if ($(location).attr("href").split('/').pop() === 'cookies-policy' || $(location).attr("href").split('/').pop() === 'politica-cookies') {
        $('#footer-cookie-policy')[0].click();
    }

    var alterClass = function () {
        var ww = document.body.clientWidth;
        if (ww < 415) {
            $('#landingPageCampaignOnline').addClass('d-none');
            $('#toggleCampaignDetails').removeClass('d-none');
            $('#toggleCampaignDetails').addClass('d-block');

        } else if (ww >= 415) {
            $('#landingPageCampaignOnline').removeClass('d-none');
            $('#toggleCampaignDetails').removeClass('d-block');
            $('#toggleCampaignDetails').addClass('d-none');
        }
        ;
    };

    $(window).resize(function () {
        alterClass();
    });
    //Fire it when the page first loads:
    alterClass();

    // Custom function which toggles between sticky class (is-sticky)
    var stickyToggle = function (sticky, stickyWrapper, scrollElement) {
        var stickyHeight = sticky.outerHeight();
        var stickyTop = stickyWrapper.offset().top;
        if (scrollElement.scrollTop() >= stickyTop) {
            stickyWrapper.height(stickyHeight);
            sticky.addClass("is-sticky");
            if (!window.location.pathname.includes('lot')) {
                $("#auctionInfo").show();
            } else {
                $("#auctionInfo").hide();
            }
        } else {
            sticky.removeClass("is-sticky");
            if (!window.location.pathname.includes('lot')) {
                $("#auctionInfo").hide();
            }
            stickyWrapper.height('auto');
        }
    };

    // Find all data-toggle="sticky-onscroll" elements
    $('[data-toggle="sticky-onscroll"]').each(function () {
        var sticky = $(this);
        var stickyWrapper = $('<div>').addClass('sticky-wrapper'); // insert hidden element to maintain actual top offset on page
        sticky.before(stickyWrapper);
        sticky.addClass('sticky');

        // Scroll & resize events
        $(window).on('scroll.sticky-onscroll resize.sticky-onscroll', function () {
            stickyToggle(sticky, stickyWrapper, $(this));
        });

        // On page load
        stickyToggle(sticky, stickyWrapper, $(window));
    });

    $('#copyToClipboard').click(function (e) {
        e.preventDefault();
        navigator.clipboard.writeText(window.location.href);
    });

    // $('#sidenav-toggle').click(function () {
    //     var isVisible = $('#sidenav').is(':visible');
    //     if (isVisible) {
    //         $('#auctionInfo').hide();
    //     } else {
    //         $('#auctionInfo').show();
    //     }
    // });


    //$('[rel=tooltip]').tooltip({trigger: "hover"});
    window.cancelLocalOffer = function (id) {

        var localSavedOffersInit = JSON.parse('[' + localStorage.getItem('localSavedOffers') + ']');
        for (var i = 0; i < localSavedOffersInit.length; i++) {
            if (localSavedOffersInit[i]['product_id'] === id) {
                localSavedOffersInit.splice(i, 1);
            }
        }
        localStorage.removeItem('localSavedOffers');

        localSavedOffersInit = JSON.stringify(localSavedOffersInit);
        localStorage.setItem('localSavedOffers', localSavedOffersInit.substring(1, localSavedOffersInit.length - 1));
        $('#' + id).remove();
        $('#separator-' + id).remove();

        if (JSON.parse('[' + localStorage.getItem('localSavedOffers') + ']').length == 0) {

            $('#offersModal').modal('hide');
            $("#offersModalBtn").hide();
            localStorage.removeItem('localSavedOffers');
        }

    };
    $('#searchSelect').change(function (e) {
        var redirect = window.location.href;
        if (redirect.includes('sort')) {
            redirect = redirect.slice(0, -1) + $('#searchSelect').val();
        } else {
            redirect = window.location + '&sort=' + $('#searchSelect').val();
        }
        window.location.replace(redirect);
    });

});

